<nz-modal
  [nzVisible]="isVisible()"
  nzTitle="Service Provider Details"
  [nzFooter]="modalFooter"
  (nzOnOk)="handleSave()"
  (nzOnCancel)="handleCancel()"
  nzWidth="80%">
  <ng-container *nzModalContent>
    <nz-row [nzGutter]="24">
      <nz-col nzSpan="12">
        <h3>Provider Information</h3>
            <form nz-form [formGroup]="form" nzLayout="vertical">
              <nz-form-item>
                      <nz-form-label nzRequired>Service Provider Name</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('clientName')"
                      [nzValidateStatus]="isFieldInvalid('clientName') ? 'error' : ''">
                          <input nz-input formControlName="clientName"  placeholder="Enter service provider name"/>
                      </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                      <nz-form-label nzRequired>Town/City</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('addressCity')"
                      [nzValidateStatus]="isFieldInvalid('addressCity') ? 'error' : ''">
                          <input nz-input formControlName="addressCity"  placeholder="Enter service provider town or city"/>
                      </nz-form-control>
                  </nz-form-item>

                  <nz-form-item>
                      <nz-form-label nzRequired>Phone</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('clientTel')"
                      [nzValidateStatus]="isFieldInvalid('clientTel') ? 'error' : ''">
                          <input nz-input formControlName="clientTel" placeholder="Enter service provider phone number"/>
                      </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                      <nz-form-label>WhatsApp</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('clientCell')"
                      [nzValidateStatus]="isFieldInvalid('clientCell') ? 'error' : ''">
                          <input nz-input formControlName="clientCell" placeholder="Enter service provider WhatsApp number"/>
                      </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                      <nz-form-label>WhatsApp Group Link</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('whatsappGroupLink')"
                      [nzValidateStatus]="isFieldInvalid('whatsappGroupLink') ? 'error' : ''">
                          <input nz-input formControlName="whatsappGroupLink" placeholder="Enter service provider WhatsApp group link" (blur)="onGroupLinkBlur()"/>
                      </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                      <nz-form-label>WhatsApp Group Name</nz-form-label>
                      <nz-form-control>
                        <ng-template #loadingSuffix>
                          @if (isLoadingGroupName()) {
                            <nz-icon nzType="loading"></nz-icon>
                          }
                        </ng-template>
                        <nz-input-group [nzSuffix]="loadingSuffix">
                          <input nz-input formControlName="whatsappGroupName" placeholder="Group name (auto-filled from link)"/>
                        </nz-input-group>
                      </nz-form-control>
                  </nz-form-item>
                  <h4>Default Pricing</h4>
                  @if (provider()?.pricingTemplate) {
                  <nz-form-item>
                      <nz-form-label nzRequired>Pricing Name</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('pricingName')"
                      [nzValidateStatus]="isFieldInvalid('pricingName') ? 'error' : ''">
                          <input nz-input formControlName="pricingName" placeholder="Enter pricing template name"/>
                      </nz-form-control>
                  </nz-form-item>
                  <nz-row [nzJustify]="'space-between'">
                    <nz-col nzSpan="10">
                      <nz-form-item>
                      <nz-form-label nzRequired>Pricing Method</nz-form-label>
                      <nz-form-control
                      [nzErrorTip]="getFieldErrorMessage('pricingMethod')"
                      [nzValidateStatus]="isFieldInvalid('pricingMethod') ? 'error' : ''">
                          <nz-select formControlName="pricingMethod" placeholder="Select pricing method">
                            <!-- For now, only "Fixed GP Percentage" is available. -->
                            <!-- <nz-option [nzValue]="1" nzLabel="Fixed"></nz-option>
                            <nz-option [nzValue]="2" nzLabel="Cost + ZAR"></nz-option> -->
                            <nz-option [nzValue]="3" nzLabel="Fixed GP Percentage"></nz-option>
                          </nz-select>
                      </nz-form-control>
                  </nz-form-item>               
                    </nz-col>
                    <nz-col nzSpan="10">
                      <nz-form-item>
                          <nz-form-label nzRequired>Pricing Value</nz-form-label>
                          <nz-form-control
                          [nzErrorTip]="getFieldErrorMessage('pricingValue')"
                          [nzValidateStatus]="isFieldInvalid('pricingValue') ? 'error' : ''">
                              <input nz-input formControlName="pricingValue" placeholder="Enter pricing value"/>
                          </nz-form-control>
                      </nz-form-item>
                      
                    </nz-col>
                  </nz-row>

                } @else {
                  <p>Default pricing will be applied after service provider is added.</p>
                }

                  <nz-form-item>
                  <nz-form-label>Coordinates</nz-form-label>
                  <nz-form-control>
                    <div style="display: flex; gap: 16px;">
                      <div style="flex: 1;">
                        <label style="font-size: 12px; color: #8c8c8c;">Latitude</label>
                        <div>{{ form.value.latitude?.toFixed(4) || 'Not set' }}</div>
                      </div>
                      <div style="flex: 1;">
                        <label style="font-size: 12px; color: #8c8c8c;">Longitude</label>
                        <div>{{ form.value.longitude?.toFixed(4) || 'Not set' }}</div>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </form>
      </nz-col>

      <nz-col nzSpan="12">
        <h3>Location</h3>
        <app-map-select
          [mapMarkerLocation]="mapLocation()"
          (locationSelected)="onLocationSelected($event)">
        </app-map-select>
      </nz-col>
    </nz-row>
  </ng-container>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button 
      nz-button 
      nzType="primary" 
      (click)="handleSave()" 
      [nzLoading]="isLoading()"
      [disabled]="form.invalid">
      Save
    </button>
  </ng-template>
</nz-modal>
